"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStageFromLocation = void 0;
var stageMap = {
    'devtest.esubcloud.com': 'branch',
    'dev.esubcloud.com': 'branch',
    'qa.esubcloud.com': 'qa',
    'stage.esubcloud.com': 'stage',
    'migration.esubcloud.com': 'branch',
    'demo.esubcloud.com': 'demo',
    'esubcloud.com': 'prod',
    'dr.esubcloud.com': 'dr',
};
var getStageFromLocation = function (location) {
    var regex = /^(?:www\.)?(?:console\.)?(.+)/i;
    var matches = regex.exec("".concat(location));
    // NOTE: match[1] contains the origin used for endpoint mapping
    var matchingUrl = Object.keys(stageMap).find(function (url) { return matches && matches[1].startsWith(url); });
    // use map value OR default to devtest
    return matchingUrl ? stageMap[matchingUrl] : 'branch';
};
exports.getStageFromLocation = getStageFromLocation;
